import type {AfriexGroupedProcessorMetrics} from '@afriex/core/domain/types';

import {Table, TBody, Td, Th, Thead, Tr} from '@/components';

import {formatTime} from './utils';

const SubProcessorTable = ({
  groupedByProcessor,
  processor,
}: {
  groupedByProcessor: AfriexGroupedProcessorMetrics;
  processor: string;
}) => {
  return (
    <Table className="w-full">
      <Thead>
        <Tr enableHover={false}>
          <Th className="px-2">Corridor Pair</Th>
          <Th className="px-2">Number of Transactions</Th>
          <Th className="px-2">Success Rate (%)</Th>
          <Th className="px-2">Average Time</Th>
        </Tr>
      </Thead>

      <TBody>
        {Object.keys(groupedByProcessor[processor]).map(
          (corridorPair, index) => (
            <SubProcessorTRow
              key={index}
              corridorPair={corridorPair}
              groupedByProcessor={groupedByProcessor}
              processor={processor}
            />
          ),
        )}
      </TBody>
    </Table>
  );
};

const SubProcessorTRow = ({
  processor,
  corridorPair,
  groupedByProcessor,
}: {
  groupedByProcessor: AfriexGroupedProcessorMetrics;
  processor: string;
  corridorPair: string;
}) => {
  const entry = groupedByProcessor[processor][corridorPair];
  const totalTx = entry.total_no_txn_per_p_cp_pi;
  const successTx = entry.success_count;
  const totalDuration = entry.total_duration;

  const successRate = totalTx > 0 ? (successTx / totalTx) * 100 : 0;
  const avgTime = successTx > 0 ? totalDuration / successTx : 0;

  return (
    <Tr>
      <Td className={`px-2 font-medium`}>{corridorPair}</Td>
      <Td className={`px-2 font-medium`}>{totalTx}</Td>
      <Td className={`px-2 font-medium`}>{successRate.toFixed(2)}</Td>
      <Td className={`px-2 font-medium`}>{formatTime(avgTime)}</Td>
    </Tr>
  );
};

export default SubProcessorTable;
